const channels = ['journey:bulk_update_handler'];

const getType = (channel) => `$atomic_update:(${channel})`;

const takeAtomicUpdate = (channel) => {
  if (!channels.includes(channel)) {
    throw new Error(`${channel} is not included in the channels list`);
  }
  return getType(channel);
};

const atomicUpdatesHandler = (dispatch, channel) => (payload) => {
  dispatch({
    type: getType(channel),
    payload,
  });
};

const getAtomicUpdatesHandlers = (dispatch) =>
  channels.reduce(
    (acc, channel) => ({ ...acc, [channel]: atomicUpdatesHandler(dispatch, channel) }),
    {}
  );

export default channels;
export { takeAtomicUpdate, getAtomicUpdatesHandlers };
